import { isArray } from '../isArray/isArray';
import { isMap } from '../isMap/isMap';
import { isObject } from '../isObject/isObject';
import { isSet } from '../isSet/isSet';
import { isString } from '../isString/isString';
/**
 * Check if passed value is empty. Checks empty object, empty arrays, empty maps, empty strings.
 *
 * @param {unknown} value Value to check.
 * @returns {boolean}
 */
export function isEmpty(value) {
    if (isString(value)) {
        return value.length === 0;
    }
    if (isArray(value)) {
        return value.length === 0;
    }
    if (isMap(value) || isSet(value)) {
        return value.size === 0;
    }
    if (isObject(value)) {
        return Object.keys(value).length === 0;
    }
    return !value;
}
